





















import { useVModel } from '@vueuse/core';
import { computed, defineComponent, PropType, ref } from '@vue/composition-api';

import { ITax } from '@/models';

import { VAutocomplete } from 'vuetify/lib/components';
import { useFetchTaxes } from '@/composable/tax';

export default defineComponent({
  name: 'TaxAutoCompletePicker',

  props: {
    value: [Array, Number, Object] as PropType<
      ITax | number | (ITax | number)[]
    >,

    errorMessages: {
      type: [String, Array] as PropType<string | string[]>
    },

    itemText: {
      type: String,
      default: 'toString()'
    }
  },

  setup(props) {
    const taxVModel = useVModel(props);

    const errorMessageList = computed(() => {
      let errorList: string[] = [];

      if (error.value) {
        errorList.push(error.value.message);
      }
      if (props.errorMessages) {
        if (Array.isArray(props.errorMessages)) {
          errorList.push(...props.errorMessages);
        } else {
          errorList.push(props.errorMessages);
        }
      }

      return errorList;
    });

    const { error, taxes, isLoading } = useFetchTaxes();

    // /** @public */
    const autocompleteRef = ref<
      InstanceType<typeof VAutocomplete> & { reset: () => void }
    >();

    /** @public */
    function reset() {
      if (autocompleteRef.value) autocompleteRef.value.reset();
    }

    return {
      reset,
      autocompleteRef,
      taxes,
      taxVModel,
      isLoading,
      errorMessageList
    };
  }
});
